import API from "../../utils/api";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { buildAssignedClientScopeParams } from "../../utils/staffListScope";
const insertUpdateInvoice = async (state) => {
  try {
    const { params, insertUpdateFlag, client_invoice_id } = state;

    const API_NAME =
      insertUpdateFlag === 0
        ? "invoice/createInvoice"
        : `invoice/updateInvoiceById/${client_invoice_id}`;
    // Remove custom headers - they're handled by the Axios interceptor
    // The interceptor automatically adds: x-access-token, user-type, user-id
    const data = await API.post(`${API_NAME}`, params);
    return data;
  } catch (error) {
    return [];
  }
};
/**
 * Updates invoice payment status by primary key (client_invoice_id).
 * Do not identify invoices by invoice_no — numbers may be duplicated.
 */
const InvoicePaymentUpdate = async ({
  client_invoice_id,
  payment_status,
  payment_method,
  amount_paid,
  remaining_total,
  cancellation_comment,
  paid_date,
  payments,
}) => {
  try {
    if (client_invoice_id === undefined || client_invoice_id === null || client_invoice_id === "") {
      throw new Error("client_invoice_id is required to update invoice payment");
    }

    const body = {
      client_invoice_id,
      payment_status,
      payment_method:
        payment_method === undefined || payment_method === ""
          ? null
          : payment_method,
      amount_paid,
      remaining_total,
    };
    if (
      cancellation_comment !== undefined &&
      cancellation_comment !== null &&
      String(cancellation_comment).trim() !== ""
    ) {
      body.cancellation_comment = String(cancellation_comment).trim();
    }
    if (
      paid_date !== undefined &&
      paid_date !== null &&
      String(paid_date).trim() !== ""
    ) {
      body.paid_date = String(paid_date).trim().slice(0, 10);
    }
    if (Array.isArray(payments) && payments.length) {
      body.payments = payments;
    }
    const response = await API.post(`invoice/PaymentStatusUpdate`, body);
    return response;
  } catch (error) {
    console.error("Failed to update invoice payment status:", error);
    throw error;
  }
};
const convertInvoice = async (state) => {
  try {
    const data = await API.get(`invoice/convertInvoiceByContractId/${state}`);
    return data;
  } catch (error) {
    return [];
  }
};

const getAllInvoices = createAsyncThunk(
  "invoice/getAllInvoicesStatus",
  async (params = {}) => {
    try {
      let body = { ...params };
      if (body.revenue_by_employee) {
        body = { ...body, revenue_by_employee: true };
      }
      body = buildAssignedClientScopeParams(body);

      const {
        data: { data },
      } = await API.post(`invoice/getAllInvoice`, body);
      return data;
    } catch (error) {
      console.log(error);
      return [];
    }
  }
);


const getCollectionInvoices = createAsyncThunk(
  "invoice/getCollectionInvoicesStatus",
  async (filters = {}) => {
    try {
      let body = { ...filters, collection: true };
      if (body.revenue_by_employee) {
        body = { ...body, revenue_by_employee: true };
      }
      console.log("Inside getCollectionInvoices API: ", body);
      const { start_date, end_date } = body;

      const query = new URLSearchParams();
      if (start_date) query.append("start_date", start_date);
      if (end_date) query.append("end_date", end_date);
      query.append("collection", true);

      const { data: { data } } = await API.post(
        `invoice/getAllInvoice?${query.toString()}`,
        buildAssignedClientScopeParams(body),
      );
      return data;
    } catch (error) {
      console.log(error);
      return [];
    }
  }
);


const getInvoiceDetail = async (invoice_id) => {
  try {
    const data = await API.get(`invoice/getInvoiceById/${invoice_id}`);
    return data;
  } catch (error) {
    console.log(error);
    return [];
  }
};

const invoicePaidUpdate = async (payload, type = "") => {
  try {
    return await API.post(`payment/${type}`, payload).then((response) => {
      if (response.status === 200 && response.data.status === 1)
        return { status: "Success", msg: response.message };
      else return { msg: response.message };
    });
  } catch (error) {
    console.error(error);
    return error;
  }
};


const deleteInvoiceById = async (Invoice_id) => {
  try {
    const data = await API.delete(`invoice/deleteInvoiceById/${Invoice_id}`);
    return data;
  } catch (error) {
    console.log(error);
    return [];
  }
};

export {
  deleteInvoiceById,
  insertUpdateInvoice,
  getInvoiceDetail,
  getAllInvoices,
  convertInvoice,
  getCollectionInvoices,
  invoicePaidUpdate,
  InvoicePaymentUpdate,
};
